import {HDate, HebrewCalendar} from '@hebcal/core';
import tractates from './tractates.json' with {type:'json'};
export {HDate,tractates};
export const TOTAL=tractates.reduce((n,t)=>n+t.last-t.first+1,0);
export const LEARNING_DAYS=Math.ceil(TOTAL/8);
export function iso(hd){const d=hd.greg();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;}
export function fromISO(s){if(!/^\d{4}-\d{2}-\d{2}$/.test(s))throw Error('בחרו תאריך התחלה תקין.');const [y,m,d]=s.split('-').map(Number);const date=new Date(y,m-1,d,12);if(date.getFullYear()!==y||date.getMonth()!==m-1||date.getDate()!==d)throw Error('תאריך ההתחלה אינו תקין.');const hd=new HDate(date);if(hd.getFullYear()<5700||hd.getFullYear()>5900)throw Error('בחרו תאריך בין השנים העבריות 5700–5900.');return hd;}
export function heb(hd){return hd.renderGematriya(false);}
export function defaultStart(){const now=new HDate();let h=new HDate(2,7,now.getFullYear());if(h.abs()<now.abs())h=new HDate(2,7,now.getFullYear()+1);return iso(h);}
function units(t){return Array.from({length:t.last-t.first+1},(_,i)=>({id:t.id,daf:t.first+i}));}
function evenPick(items,n){if(n<=0)return [];if(n>=items.length)return [...items];return Array.from({length:n},(_,i)=>items[Math.floor((i+.5)*items.length/n)]);}
function rangeAbs(a,b){return Array.from({length:b-a+1},(_,i)=>a+i);}
function nextAnniversary(h){
 // Adar II -> Adar in a common year; Adar in a common year -> Adar II in a leap year.
 let y=h.getFullYear()+1,m=h.getMonth();
 if(m===13&&!HDate.isLeapYear(y))m=12;
 else if(m===12&&!h.isLeapYear()&&HDate.isLeapYear(y))m=13;
 return new HDate(Math.min(h.getDate(),HDate.daysInMonth(m,y)),m,y);
}
function holidayData(start,end,il){
 const map=new Map();const fasts=new Set();
 for(const event of HebrewCalendar.calendar({start,end,il,noModern:true,locale:'he'})){
  const abs=event.getDate().abs(),name=event.render('he-x-NoNikud');
  if(!map.has(abs))map.set(abs,[]);map.get(abs).push(name);
  if(event.getDesc().startsWith("Tish'a B'Av"))fasts.add(abs);
 }
 return {map,fasts};
}
function plans(start,end,il,sukkotDay){
 const lo=start.abs(),hi=end.abs(),specs=[];
 function add(id,finish,begin,label){if(finish.abs()>=lo&&finish.abs()<=hi)specs.push({id,finish:finish.abs(),begin:begin?.abs(),label});}
 for(let y=start.getFullYear()-1;y<=end.getFullYear()+1;y++){
  const adar=HDate.isLeapYear(y)?13:12;
  const erevPurim=new HDate(13,adar,y);
  add('rosh-hashanah',new HDate(1,7,y),null,'סיום ראש השנה — א׳ בתשרי');
  add('yoma',new HDate(10,7,y),new HDate(2,7,y),'סיום יומא — יום הכיפורים');
  add('sukkah',new HDate(sukkotDay,7,y),new HDate(11,7,y),'סיום סוכה — '+(sukkotDay===15?'א׳':'ב׳')+' דסוכות');
  add('megillah',erevPurim,null,'סיום מגילה — ערב פורים (י״ג באדר)');
  add('pesachim',new HDate(14,1,y),null,'סיום פסחים — ערב פסח');
  add('moed-katan',new HDate(20,1,y),new HDate(il?16:17,1,y),'מועד קטן — חול המועד פסח');
  add('chagigah',new HDate(6,3,y),null,'סיום חגיגה — שבועות');
  add('taanit',new HDate(1,5,y),null,'סיום תענית — ראש חודש אב');
  add('tamid',new HDate(3,5,y),new HDate(2,5,y),'תמיד — מתחילים בב׳ באב');
 }
 return specs.sort((a,b)=>a.finish-b.finish);
}
export function durationParts(start,days){
 const a=start.greg(),b=start.add(days,'days').greg();let months=(b.getFullYear()-a.getFullYear())*12+b.getMonth()-a.getMonth();
 const shifted=n=>{const d=new Date(a.getFullYear(),a.getMonth()+n,1,12);d.setDate(Math.min(a.getDate(),new Date(d.getFullYear(),d.getMonth()+1,0).getDate()));return new HDate(d);};
 if(shifted(months).abs()>new HDate(b).abs())months--;
 return {years:Math.floor(months/12),months:months%12,days:new HDate(b).abs()-shifted(months).abs()};
}
export function makeSteady({startDate,dailyDaf=8,il=true}){
 const pace=Number(dailyDaf);if(!Number.isInteger(pace)||pace<1||pace>100)throw Error('בחרו מספר שלם בין 1 ל־100 דפים ביום.');
 const start=fromISO(startDate),all=tractates.flatMap(units),count=Math.ceil(TOTAL/pace),end=start.add(count-1,'days');
 const {map}=holidayData(start,end,il);
 const days=Array.from({length:count},(_,i)=>{const hd=start.add(i,'days');return {abs:hd.abs(),hd,units:all.slice(i*pace,(i+1)*pace),labels:map.get(hd.abs())||[],review:false,fast:false,target:null};});
 return {days,start,end,finish:end,total:TOTAL,mode:'steady',il,targets:[],learningDays:count,reviewDays:0,shabbatDays:0,peak:pace,dailyDaf:pace,duration:durationParts(start,count)};
}
export function makeSchedule({startDate,mode='eight',il=true,sukkotDay=16,shabbatReview=true,dailyDaf=8}){
 if(mode==='steady')return makeSteady({startDate,dailyDaf,il});
 if(!['eight','holidays'].includes(mode)||![15,16].includes(Number(sukkotDay)))throw Error('בחרו מסלול והגדרות תקינים.');
 const start=fromISO(startDate),end=nextAnniversary(start).subtract(1,'day');
 const lo=start.abs(),hi=end.abs();const {map,fasts}=holidayData(start,end,il);
 const days=rangeAbs(lo,hi).map(abs=>({abs,hd:new HDate(abs),units:[],labels:map.get(abs)||[],review:false,fast:fasts.has(abs),target:null}));
 const byAbs=new Map(days.map(d=>[d.abs,d]));const usedTractates=new Set(),targets=[];
 if(mode==='holidays'){
  const specs=plans(start,end,il,Number(sukkotDay));
  if(specs.length!==9||new Set(specs.map(s=>s.id)).size!==9)throw Error('בטווח זה חסר יעד חג שנתי או שהוא מופיע פעמיים. נסו התחלה בב׳ בתשרי, או בחרו במסלול שמונה ליום.');
  for(const s of specs){
   const t=tractates.find(t=>t.id===s.id),u=units(t);
   const begin=s.begin??s.finish-Math.ceil(u.length/8)+1;
   if(begin<lo)throw Error(`כדי להשלים ${t.name} במועד, יש להתחיל עד ${heb(new HDate(begin))}. בחרו תאריך מוקדם יותר, או עברו לשמונה ליום.`);
   const slots=rangeAbs(begin,s.finish).map(a=>byAbs.get(a));
   if(slots.some(d=>!d||d.target||d.fast))throw Error(`נוצרה התנגשות בימי ${t.name}. נסו התחלה בב׳ בתשרי או במסלול שמונה ליום.`);
   let cursor=0;const base=Math.floor(u.length/slots.length),extra=u.length%slots.length;
   slots.forEach((d,i)=>{const n=base+(i<extra?1:0);d.units=u.slice(cursor,cursor+n);cursor+=n;d.target=s.id;});
   byAbs.get(s.finish).labels.push(s.label);if(s.id==='tamid')byAbs.get(begin).labels.push('תחילת תמיד — ב׳ באב');
   usedTractates.add(s.id);targets.push({...s,begin,count:u.length,peak:Math.ceil(u.length/slots.length),name:t.name});
  }
 }
 const remaining=tractates.filter(t=>!usedTractates.has(t.id)).flatMap(units);
 const free=days.filter(d=>!d.target&&!d.fast),needed=Math.ceil(remaining.length/8);
 if(free.length<needed)throw Error('אין מספיק ימים להשלמת כל המסכתות בקצב שנבחר. בחרו תאריך התחלה אחר.');
 const spare=free.length-needed;
 const reserved=new Set();
 if(shabbatReview){
  const sats=free.filter(d=>d.hd.getDay()===6&&d.abs!==hi).map(d=>d.abs);
  evenPick(sats,Math.min(spare,sats.length)).forEach(a=>reserved.add(a));
  if(reserved.size<spare){const extra=free.filter(d=>!reserved.has(d.abs)&&d.abs!==hi).map(d=>d.abs);evenPick(extra,spare-reserved.size).forEach(a=>reserved.add(a));}
 }
 let pos=0;
 for(const d of days){
  if(d.target)continue;
  if(d.fast){d.review=true;continue;}
  if(reserved.has(d.abs)||pos>=remaining.length){d.review=true;continue;}
  d.units=remaining.slice(pos,pos+8);pos+=d.units.length;
 }
 if(pos!==remaining.length)throw Error('לא הושלמה חלוקת כל הדפים.');
 const seen=new Set();for(const d of days)for(const u of d.units){const k=u.id+':'+u.daf;if(seen.has(k))throw Error('נמצאה כפילות בחלוקה.');seen.add(k);}
 if(seen.size!==TOTAL)throw Error('ספירת הדפים אינה שלמה.');
 const learned=days.filter(d=>d.units.length),finish=learned.at(-1).hd;
 return {days,start,end,finish,total:TOTAL,mode,il,targets,learningDays:learned.length,reviewDays:days.filter(d=>d.review&&!d.fast).length,shabbatDays:days.filter(d=>d.review&&!d.fast&&d.hd.getDay()===6).length,peak:Math.max(...days.map(d=>d.units.length)),leap:start.isLeapYear()||end.isLeapYear()};
}
export function segments(day){
 const out=[];for(const u of day.units){let s=out.at(-1);if(s&&s.id===u.id&&s.last+1===u.daf)s.last=u.daf;else out.push({id:u.id,first:u.daf,last:u.daf});}return out;
}
export function segmentText(s){const t=tractates.find(t=>t.id===s.id);const first=s.id==='tamid'&&s.first===25?'25ב':String(s.first);return `${t.name} ${first}${s.last!==s.first?'–'+s.last:''}`;}
